
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Harsh Kanani",
  title: "Hi all, I'm Harsh",
  subTitle: emoji("Welcome to my place of passion. Programming is not only my passion but is something that I developed over time with great effort. I am driven by my insatiable fascination for Computers I learn something new every day as there is so much yet to learn."),
  resumeLink: "https://drive.google.com/file/d/1TTrxB-0L8ikbVLz80WPRYmVposL5z33r/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/harshkanani014",
  linkedin: "https://www.linkedin.com/in/harsh-kanani-69a45818b/",
  hackerrank: "https://www.hackerrank.com/harshkanani014",
  gmail: "harshkanani100@gmail.com",
  facebook: "https://www.facebook.com/harsh.kanani.94/",
  instagram: "https://www.instagram.com/harsh_kanani23/",
  telegram: "https://t.me/coder",
  
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle: "CRAZY FULL STACK DEVELOPER AND COMPETITIVE PROGRAMMER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },

    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
  
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },

    
  ]
};

// Your education background

const educationInfo = {
  viewEducation: true, // Set it to true to see education section
  schools: [
    {
      schoolName: "Vellore Institute of Technology - vellore",
      logo: require("./assets/images/VIT_logo.png"),
      subHeader: "B.tech in Computer Science",
      duration: "July 2019 - April 2023",
      desc: "",
      descBullets: [
        "CGPA : 9.08 (till winter sem 19-20)",
        "Event Co-ordinator at gravitas 2020 (Asia's biggest tech fest)"
      ]
    },
    
  ]
}

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",  //Insert stack or technology you have experience in
      progressPercentage: "80%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "50%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Intern",
      company: "Samsung",
      companylogo: require("./assets/images/samsung_logo.png"),
      date: "September 2020 – Present",
      desc: "Currently working on research based project on Internet of things (IOT)",
      descBullets: [
        "worklet name : IoT Connectivity | OCF-oneM2M Bi-directional Bridge for IoTivity",
      ]
    },
    {
      role: "Core commitee member",
      company: "IEEE - Computer Society VIT",
      companylogo: require("./assets/images/ieee_cs.png"),
      date: "December 2019 – present",
      desc: "CCM at IEEE-CS VIT (one of the best chapter of world) currently working in web development and competitive programming domain"
    },
    
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "harshkanani014", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      link: "http://saayahealth.com/"
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      link: "http://nextu.se/"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "4 star coder at codechef",
      subtitle: "",
      image: require("./assets/images/codechef.png"),
      footerLink: [
        { name: "https://www.codechef.com/users/harshkanani004", url: "https://www.codechef.com/users/harshkanani004" }
      ]
    },
    {
      title: "HackerRank skill certification for Python",
      subtitle: "",
      image: require("./assets/images/hackerRank.png"),
      footerLink: [{ name: "Certification", url: "https://www.hackerrank.com/certificates/4300c1af9487" }]
    },

    {
      title: "HackerRank skill certification for Problem Solving",
      subtitle: "",
      image: require("./assets/images/hackerRank.png"),
      footerLink: [
        { name: "Certification", url: "https://www.hackerrank.com/certificates/431d6bd8ce2c" }
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9909115227",
  email_address: "harshkanani100@gmail.com"
};

//Twitter Section

const twitterDetails = {

  userName : "twitter"//Replace "twitter" with your twitter username without @

};
export { greeting, socialMediaLinks, skillsSection, educationInfo, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo , twitterDetails};
